import React, { useState, useEffect } from "react";
import { formAPI } from "../../../../../services/api";
import "./11Statistics.css";

const VIP11Statistics = ({ projectId }) => {
  const [loading, setLoading] = useState(true);
  const [statistics, setStatistics] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStatistics = async () => {
      try {
        console.log("Fetching statistics with projectId:", projectId);
        setLoading(true);

        // projectId가 없는 경우 세션 스토리지에서 시도
        const effectiveProjectId = projectId || "neuro-icu11";

        console.log("Making API call with projectId:", effectiveProjectId);
        const response = await formAPI.getDataNumber(effectiveProjectId);
        console.log("API Response:", response);

        // 병원 A-I까지의 데이터 초기화
        const hospitalStats = {};
        for (let i = 65; i <= 73; i++) {
          // ASCII: A-I
          const hospital = String.fromCharCode(i);
          hospitalStats[hospital] = {
            total_count: 0,
            last_7_days: 0,
            last_30_days: 0,
          };
        }

        // API 응답 데이터로 업데이트
        if (response.success && response.data) {
          console.log("Processing response data:", response.data);
          response.data.forEach((stat) => {
            if (hospitalStats[stat.hospital]) {
              hospitalStats[stat.hospital] = {
                total_count: stat.total_count || 0,
                last_7_days: stat.last_7_days || 0,
                last_30_days: stat.last_30_days || 0,
              };
            }
          });
        }

        console.log("Final hospital stats:", hospitalStats);
        setStatistics(hospitalStats);
      } catch (err) {
        console.error("Statistics fetch error:", err);
        setError(err.message || "데이터 조회 중 오류가 발생했습니다");
      } finally {
        setLoading(false);
      }
    };

    fetchStatistics();
  }, [projectId]);

  if (loading) {
    return (
      <div className="statistics-loading">
        <div className="loading-spinner"></div>
        <div className="loading-text">데이터를 불러오는 중입니다...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="statistics-error">
        <div className="error-icon">⚠️</div>
        <div className="error-message">데이터 조회 중 오류가 발생했습니다</div>
        <div className="error-detail">{error}</div>
        <button
          onClick={() => window.location.reload()}
          style={{
            marginTop: "20px",
            padding: "8px 16px",
            backgroundColor: "#1976D2",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          다시 시도
        </button>
      </div>
    );
  }

  return (
    <div className="vip11-statistics">
      <div className="statistics-header">
        <h2>기관별 데이터 수집 현황</h2>
        <p>각 기관의 전체 데이터 건수 및 최근 생성된 데이터 현황</p>
      </div>

      <div className="hospital-grid">
        {Object.entries(statistics).map(([hospital, stats]) => (
          <div key={hospital} className="hospital-card">
            <div className="hospital-header">
              <h3>기관 {hospital}</h3>
              <div className="total-badge">{stats.total_count}건</div>
            </div>
            <div className="stats-content">
              <div className="stat-row">
                <div className="stat-item">
                  <div className="stat-label">최근 7일</div>
                  <div className="stat-value">
                    <span className="number">{stats.last_7_days}</span>
                    <span className="unit">건</span>
                  </div>
                </div>
                <div className="stat-item">
                  <div className="stat-label">최근 30일</div>
                  <div className="stat-value">
                    <span className="number">{stats.last_30_days}</span>
                    <span className="unit">건</span>
                  </div>
                </div>
              </div>
              <div className="trend-indicator">
                {stats.last_7_days > 0 ? (
                  <span className="trend-positive">최근 7일간 활성화됨</span>
                ) : (
                  <span className="trend-negative">최근 7일간 데이터 없음</span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VIP11Statistics;
